import axios from "axios";
import {
  createAPIPromise,
  createLoadingPromise,
  loadingUrls,
} from "./utils/common";

/**
 * 規約取得APIのレスポンス
 */
export type TGetTerm = {
  data: {
    statusCode: number;
    message: string;
    result: {
      pdfData: string;
      termsVersion: string;
    };
  };
};

// 規約取得API
const get: (
  authHeader: string,
  termsNumber: number
  // eslint-disable-next-line
) => Promise<TGetTerm> = async (authHeader: string, termsNumber: number) => {
  const path = `/terms/${termsNumber}`;
  if (loadingUrls.includes(path)) {
    return createLoadingPromise();
  }
  // 通信中登録
  loadingUrls.push(path);
  return createAPIPromise(
    axios.get(`${process.env.REACT_APP_API_DOMAIN as string}${path}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
      data: {},
    }),
    path
  );
};

// 規約一覧取得API
// eslint-disable-next-line
const getLatestList: (authHeader: string) => Promise<any> = async (
  authHeader: string
) => {
  const path = `/terms`;
  if (loadingUrls.includes(path)) {
    return createLoadingPromise();
  }
  // 通信中登録
  loadingUrls.push(path);
  return createAPIPromise(
    axios.get(`${process.env.REACT_APP_API_DOMAIN as string}${path}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
      data: {},
    }),
    path
  );
};

export default { get, getLatestList };
